/**
 * Nota per il cliente alla chiusura "non impattato" di un ticket manuale.
 *
 * Stessa regola del server (product-service `ticket-customer-note.ts`): parole = token separati
 * da spazi bianchi (spazi, tab, a capo) dopo il trim, i token vuoti non contano; la nota è
 * sufficiente se `parole >= minimo` (default 100, configurabile da /admin). Il server la
 * ricontrolla alla chiusura (422 CUSTOMER_NOTE_REQUIRED / CUSTOMER_NOTE_TOO_SHORT).
 */

/** Minimo di parole finché /admin/ticket-settings non risponde (default di servizio). */
export const DEFAULT_CUSTOMER_NOTE_MIN_WORDS = 100;

/** Numero di parole della nota: token separati da spazi bianchi, dopo il trim. */
export function countWords(text: string): number {
  const t = text.trim();
  return t ? t.split(/\s+/).filter(Boolean).length : 0;
}

/** La nota raggiunge il minimo richiesto (`parole >= minimo`). */
export function isCustomerNoteLongEnough(text: string, minWords: number): boolean {
  return countWords(text) >= minWords;
}
